<template>
  <v-dialog v-model="dialog" :max-width="dialogWidth" class="modern-dialog">
    <v-card class="modern-dialog-card">
      <v-card-title>
        {{ title }}
        <v-spacer></v-spacer>
        <span class="subtitle-1">{{ hostName }}</span>
      </v-card-title>
      <v-card-text class="px-4 py-3" :class="{ 'position-relative': loading }">
        <v-overlay v-if="loading" absolute class="d-flex align-center justify-center" :value="loading">
          <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
        </v-overlay>
        <v-form ref="form" v-model="valid">
          <div v-if="selectedHost && (selectedHost.hasVCON || selectedHost.hasVPRA || selectedHost.hasVSUC || selectedHost.hasVSUP || selectedHost.hasVSYN)" class="d-flex justify-space-around align-center sistemas-container">
            <!-- VCON -->
            <div v-if="selectedHost && selectedHost.hasVCON" class="system-cronograma-container flex-shrink-0 position-relative">
              <div
                v-if="scoresSistemas.VCON"
                class="score-indicator"
                :title="getScoreTooltip(scoresSistemas.VCON)"
              >
                <div v-if="deveMostrarIcone(scoresSistemas.VCON)" class="score-icon-only">
                  <span class="score-icon">{{ getScoreIcon(scoresSistemas.VCON) }}</span>
                </div>
                <template v-else>
                  <svg class="score-circle" viewBox="0 0 100 100">
                    <circle
                      class="score-circle-bg"
                      cx="50"
                      cy="50"
                      r="45"
                    ></circle>
                    <circle
                      class="score-circle-progress"
                      :class="getScoreCircleClass(scoresSistemas.VCON)"
                      cx="50"
                      cy="50"
                      r="45"
                      :stroke-dasharray="getScoreDashArray(scoresSistemas.VCON)"
                      :stroke-dashoffset="getScoreDashOffset(scoresSistemas.VCON)"
                    ></circle>
                  </svg>
                  <div class="score-content">
                    <div class="score-number">{{ getScoreNumber(scoresSistemas.VCON) }}</div>
                  </div>
                </template>
              </div>
              <div class="text-center mb-3">
                <div
                  class="system-icon-container-large"
                  :class="{ 'active': form.vcon, 'inactive': !form.vcon }"
                >
                  <img 
                    :src="getIconeSistema('VCON')" 
                    :alt="'VCON'"
                    class="sistema-icon-large"
                    :title="'VCON'"
                  />
                </div>
                <div class="mt-2">
                  <strong>VCON</strong>
                  <div class="caption" :class="form.vcon ? 'success--text' : 'grey--text'">
                    {{ form.vcon ? 'Ativo' : 'Inativo' }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-center mt-2">
              <v-checkbox 
                v-model="form.vcon"
                :label="'Ativar'"
                  :disabled="isSistemaBloqueado('VCON')"
                hide-details
              ></v-checkbox>
                <v-tooltip v-if="isSistemaBloqueado('VCON')" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      small 
                      color="error" 
                      class="ml-1"
                      v-bind="attrs"
                      v-on="on"
                    >mdi-alert-circle</v-icon>
                  </template>
                  <span>{{ getMensagemBloqueio('VCON') }}</span>
                </v-tooltip>
              </div>
              <v-text-field
                v-model="form.horarioVcon"
                type="time"
                :disabled="!form.vcon"
                label="Horário"
                class="mt-2"
                hide-details
                outlined
                dense
                mask="##:##"
                placeholder="HH:MM"
              ></v-text-field>
            </div>

            <!-- VPRA -->
            <div v-if="selectedHost && selectedHost.hasVPRA" class="system-cronograma-container flex-shrink-0 position-relative">
              <div
                v-if="scoresSistemas.VPRA"
                class="score-indicator"
                :title="getScoreTooltip(scoresSistemas.VPRA)"
              >
                <div v-if="deveMostrarIcone(scoresSistemas.VPRA)" class="score-icon-only">
                  <span class="score-icon">{{ getScoreIcon(scoresSistemas.VPRA) }}</span>
                </div>
                <template v-else>
                  <svg class="score-circle" viewBox="0 0 100 100">
                    <circle
                      class="score-circle-bg"
                      cx="50"
                      cy="50"
                      r="45"
                    ></circle>
                    <circle
                      class="score-circle-progress"
                      :class="getScoreCircleClass(scoresSistemas.VPRA)"
                      cx="50"
                      cy="50"
                      r="45"
                      :stroke-dasharray="getScoreDashArray(scoresSistemas.VPRA)"
                      :stroke-dashoffset="getScoreDashOffset(scoresSistemas.VPRA)"
                    ></circle>
                  </svg>
                  <div class="score-content">
                    <div class="score-number">{{ getScoreNumber(scoresSistemas.VPRA) }}</div>
                  </div>
                </template>
              </div>
              <div class="text-center mb-3">
                <div
                  class="system-icon-container-large"
                  :class="{ 'active': form.vpra, 'inactive': !form.vpra }"
                >
                  <img 
                    :src="getIconeSistema('VPRA')" 
                    :alt="'VPRA'"
                    class="sistema-icon-large"
                    :title="'VPRA'"
                  />
                </div>
                <div class="mt-2">
                  <strong>VPRA</strong>
                  <div class="caption" :class="form.vpra ? 'success--text' : 'grey--text'">
                    {{ form.vpra ? 'Ativo' : 'Inativo' }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-center mt-2">
              <v-checkbox 
                v-model="form.vpra"
                :label="'Ativar'"
                  :disabled="isSistemaBloqueado('VPRA')"
                hide-details
              ></v-checkbox>
                <v-tooltip v-if="isSistemaBloqueado('VPRA')" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      small 
                      color="error" 
                      class="ml-1"
                      v-bind="attrs"
                      v-on="on"
                    >mdi-alert-circle</v-icon>
                  </template>
                  <span>{{ getMensagemBloqueio('VPRA') }}</span>
                </v-tooltip>
              </div>
              <v-text-field
                v-model="form.horarioVpra"
                type="time"
                :disabled="!form.vpra"
                label="Horário"
                class="mt-2"
                hide-details
                outlined
                dense
                mask="##:##"
                placeholder="HH:MM"
              ></v-text-field>
            </div>

            <!-- VSUC -->
            <div v-if="selectedHost && selectedHost.hasVSUC" class="system-cronograma-container flex-shrink-0 position-relative">
              <div
                v-if="scoresSistemas.VSUC"
                class="score-indicator"
                :title="getScoreTooltip(scoresSistemas.VSUC)"
              >
                <div v-if="deveMostrarIcone(scoresSistemas.VSUC)" class="score-icon-only">
                  <span class="score-icon">{{ getScoreIcon(scoresSistemas.VSUC) }}</span>
                </div>
                <template v-else>
                  <svg class="score-circle" viewBox="0 0 100 100">
                    <circle
                      class="score-circle-bg"
                      cx="50"
                      cy="50"
                      r="45"
                    ></circle>
                    <circle
                      class="score-circle-progress"
                      :class="getScoreCircleClass(scoresSistemas.VSUC)"
                      cx="50"
                      cy="50"
                      r="45"
                      :stroke-dasharray="getScoreDashArray(scoresSistemas.VSUC)"
                      :stroke-dashoffset="getScoreDashOffset(scoresSistemas.VSUC)"
                    ></circle>
                  </svg>
                  <div class="score-content">
                    <div class="score-number">{{ getScoreNumber(scoresSistemas.VSUC) }}</div>
                  </div>
                </template>
              </div>
              <div class="text-center mb-3">
                <div
                  class="system-icon-container-large"
                  :class="{ 'active': form.vsuc, 'inactive': !form.vsuc }"
                >
                  <img 
                    :src="getIconeSistema('VSUC')" 
                    :alt="'VSUC'"
                    class="sistema-icon-large"
                    :title="'VSUC'"
                  />
                </div>
                <div class="mt-2">
                  <strong>VSUC</strong>
                  <div class="caption" :class="form.vsuc ? 'success--text' : 'grey--text'">
                    {{ form.vsuc ? 'Ativo' : 'Inativo' }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-center mt-2">
              <v-checkbox 
                v-model="form.vsuc"
                :label="'Ativar'"
                  :disabled="isSistemaBloqueado('VSUC')"
                hide-details
              ></v-checkbox>
                <v-tooltip v-if="isSistemaBloqueado('VSUC')" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      small 
                      color="error" 
                      class="ml-1"
                      v-bind="attrs"
                      v-on="on"
                    >mdi-alert-circle</v-icon>
                  </template>
                  <span>{{ getMensagemBloqueio('VSUC') }}</span>
                </v-tooltip>
              </div>
              <v-text-field
                v-model="form.horarioVsuc"
                type="time"
                :disabled="!form.vsuc"
                label="Horário"
                class="mt-2"
                hide-details
                outlined
                dense
                mask="##:##"
                placeholder="HH:MM"
              ></v-text-field>
            </div>

            <!-- VSUP -->
            <div v-if="selectedHost && selectedHost.hasVSUP" class="system-cronograma-container flex-shrink-0 position-relative">
              <div
                v-if="scoresSistemas.VSUP"
                class="score-indicator"
                :title="getScoreTooltip(scoresSistemas.VSUP)"
              >
                <div v-if="deveMostrarIcone(scoresSistemas.VSUP)" class="score-icon-only">
                  <span class="score-icon">{{ getScoreIcon(scoresSistemas.VSUP) }}</span>
                </div>
                <template v-else>
                  <svg class="score-circle" viewBox="0 0 100 100">
                    <circle
                      class="score-circle-bg"
                      cx="50"
                      cy="50"
                      r="45"
                    ></circle>
                    <circle
                      class="score-circle-progress"
                      :class="getScoreCircleClass(scoresSistemas.VSUP)"
                      cx="50"
                      cy="50"
                      r="45"
                      :stroke-dasharray="getScoreDashArray(scoresSistemas.VSUP)"
                      :stroke-dashoffset="getScoreDashOffset(scoresSistemas.VSUP)"
                    ></circle>
                  </svg>
                  <div class="score-content">
                    <div class="score-number">{{ getScoreNumber(scoresSistemas.VSUP) }}</div>
                  </div>
                </template>
              </div>
              <div class="text-center mb-3">
                <div
                  class="system-icon-container-large"
                  :class="{ 'active': form.vsup, 'inactive': !form.vsup }"
                >
                  <img 
                    :src="getIconeSistema('VSUP')" 
                    :alt="'VSUP'"
                    class="sistema-icon-large"
                    :title="'VSUP'"
                  />
                </div>
                <div class="mt-2">
                  <strong>VSUP</strong>
                  <div class="caption" :class="form.vsup ? 'success--text' : 'grey--text'">
                    {{ form.vsup ? 'Ativo' : 'Inativo' }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-center mt-2">
              <v-checkbox 
                v-model="form.vsup"
                :label="'Ativar'"
                  :disabled="isSistemaBloqueado('VSUP')"
                hide-details
              ></v-checkbox>
                <v-tooltip v-if="isSistemaBloqueado('VSUP')" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      small 
                      color="error" 
                      class="ml-1"
                      v-bind="attrs"
                      v-on="on"
                    >mdi-alert-circle</v-icon>
                  </template>
                  <span>{{ getMensagemBloqueio('VSUP') }}</span>
                </v-tooltip>
              </div>
              <v-text-field
                v-model="form.horarioVsup"
                type="time"
                :disabled="!form.vsup"
                label="Horário"
                class="mt-2"
                hide-details
                outlined
                dense
                mask="##:##"
                placeholder="HH:MM"
              ></v-text-field>
            </div>

            <!-- VSYN -->
            <div v-if="selectedHost && selectedHost.hasVSYN" class="system-cronograma-container flex-shrink-0 position-relative">
              <div
                v-if="scoresSistemas.VSYN"
                class="score-indicator"
                :title="getScoreTooltip(scoresSistemas.VSYN)"
              >
                <div v-if="deveMostrarIcone(scoresSistemas.VSYN)" class="score-icon-only">
                  <span class="score-icon">{{ getScoreIcon(scoresSistemas.VSYN) }}</span>
                </div>
                <template v-else>
                  <svg class="score-circle" viewBox="0 0 100 100">
                    <circle
                      class="score-circle-bg"
                      cx="50"
                      cy="50"
                      r="45"
                    ></circle>
                    <circle
                      class="score-circle-progress"
                      :class="getScoreCircleClass(scoresSistemas.VSYN)"
                      cx="50"
                      cy="50"
                      r="45"
                      :stroke-dasharray="getScoreDashArray(scoresSistemas.VSYN)"
                      :stroke-dashoffset="getScoreDashOffset(scoresSistemas.VSYN)"
                    ></circle>
                  </svg>
                  <div class="score-content">
                    <div class="score-number">{{ getScoreNumber(scoresSistemas.VSYN) }}</div>
                  </div>
                </template>
              </div>
              <div class="text-center mb-3">
                <div
                  class="system-icon-container-large"
                  :class="{ 'active': form.vsyn, 'inactive': !form.vsyn }"
                >
                  <img 
                    :src="getIconeSistema('VSYN')" 
                    :alt="'VSYN'"
                    class="sistema-icon-large"
                    :title="'VSYN'"
                  />
                </div>
                <div class="mt-2">
                  <strong>VSYN</strong>
                  <div class="caption" :class="form.vsyn ? 'success--text' : 'grey--text'">
                    {{ form.vsyn ? 'Ativo' : 'Inativo' }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-center mt-2">
              <v-checkbox 
                v-model="form.vsyn"
                :label="'Ativar'"
                  :disabled="isSistemaBloqueado('VSYN')"
                hide-details
              ></v-checkbox>
                <v-tooltip v-if="isSistemaBloqueado('VSYN')" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      small 
                      color="error" 
                      class="ml-1"
                      v-bind="attrs"
                      v-on="on"
                    >mdi-alert-circle</v-icon>
                  </template>
                  <span>{{ getMensagemBloqueio('VSYN') }}</span>
                </v-tooltip>
              </div>
              <v-text-field
                v-model="form.horarioVsyn"
                type="time"
                :disabled="!form.vsyn"
                label="Horário"
                class="mt-2"
                hide-details
                outlined
                dense
                mask="##:##"
                placeholder="HH:MM"
              ></v-text-field>
            </div>
          </div>

          <!-- Botão Ativar/Desativar Tudo -->
          <div v-if="selectedHost && (selectedHost.hasVCON || selectedHost.hasVPRA || selectedHost.hasVSUC || selectedHost.hasVSUP || selectedHost.hasVSYN)" class="d-flex justify-center pa-2 ativar-tudo-container">
            <v-btn
              :color="todosAtivados ? 'error' : 'success'"
              @click="toggleAtivarTudo"
              outlined
              small
            >
              <v-icon left>{{ todosAtivados ? 'mdi-checkbox-multiple-marked' : 'mdi-checkbox-multiple-blank' }}</v-icon>
              {{ todosAtivados ? 'Desativar Tudo' : 'Ativar Tudo' }}
            </v-btn>
          </div>

          <!-- Botão de Sugestão de Horário -->
          <div v-if="selectedHost && (selectedHost.hasVCON || selectedHost.hasVPRA || selectedHost.hasVSUC || selectedHost.hasVSUP || selectedHost.hasVSYN)" class="d-flex align-center justify-center horario-sugestao-container">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="horarioMinimo"
                  type="time"
                  label="Horário Mínimo"
                  outlined
                  dense
                  :error-messages="erroHorarioMinimo"
                  style="max-width: 150px;"
                  mask="##:##"
                  placeholder="HH:MM"
                  v-bind="attrs"
                  v-on="on"
                  @blur="validarHorarioMinimo"
                  hide-details="auto"
                ></v-text-field>
              </template>
              <span>Defina um horário de ao menos 30 minutos a mais após fim do horário de backup</span>
            </v-tooltip>
            <v-btn
              color="primary"
              @click="aplicarSugestaoHorarios"
              :loading="carregandoSugestao"
              :disabled="!temSistemasSelecionados || !!erroHorarioMinimo"
              style="height: 40px;"
            >
              <v-icon left>mdi-lightbulb-on</v-icon>
              Sugestão de Horário
            </v-btn>
          </div>

          <!-- Mensagem quando não há sistemas -->
          <div v-if="selectedHost && !selectedHost.hasVCON && !selectedHost.hasVPRA && !selectedHost.hasVSUC && !selectedHost.hasVSUP && !selectedHost.hasVSYN" class="text-center pa-4">
            <v-alert type="info" text>
              Este host não possui nenhum dos sistemas configurados.
            </v-alert>
          </div>
          
          <!-- Aviso sobre score -->
          <div v-if="selectedHost && (selectedHost.hasVPRA || selectedHost.hasVSUC || selectedHost.hasVSUP || selectedHost.hasVCON || selectedHost.hasVSYN)" class="text-center mb-2">
            <small class="font-italic grey--text">
              Quanto mais baixo o score, mais seguro o sistema está para atualizar
            </small>
          </div>
          
          <!-- Divisor para separar opções dos sistemas da configuração de logs -->
          <v-divider v-if="selectedHost && (selectedHost.hasVPRA || selectedHost.hasVSUC || selectedHost.hasVSUP || selectedHost.hasVCON || selectedHost.hasVSYN)" class="my-4"></v-divider>
          
          <!-- Opção para gravação de vídeo -->
          <div v-if="selectedHost && (selectedHost.hasVPRA || selectedHost.hasVSUC || selectedHost.hasVSUP || selectedHost.hasVCON || selectedHost.hasVSYN)" class="d-flex align-center pa-2">
            <v-checkbox v-model="form.logsVideo" class="mr-3"></v-checkbox>
            <div>
              <div class="d-flex align-center">
                <v-icon left color="red" small>mdi-video</v-icon>
                <strong class="text-h6">Gravação de Vídeo</strong>
              </div>
            </div>
          </div>
        </v-form>

        <!-- Validação de horários -->
        <v-alert v-if="horariosConflitantes.length > 0" type="error" outlined class="mt-3">
          <div class="d-flex align-center">
            <v-icon left>mdi-alert-circle</v-icon>
            <strong>Conflito de Horários Detectado!</strong>
          </div>
          <ul class="mt-2">
            <li v-for="conflito in horariosConflitantes" :key="conflito">
              {{ conflito }}
            </li>
          </ul>
          <div class="mt-2">
            <small>
              <strong>Regras:</strong>
              <br>• Sistemas não podem executar no mesmo horário
              <br>• Deve haver no mínimo 10 minutos entre a execução de sistemas diferentes
            </small>
          </div>
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="cancel">
          Cancelar
        </v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="save"
          :disabled="!selectedHost || (!selectedHost.hasVCON && !selectedHost.hasVPRA && !selectedHost.hasVSUC && !selectedHost.hasVSUP && !selectedHost.hasVSYN) || temConflitosHorario || loading"
          :loading="loading"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import HorarioValidator from '@/utils/HorarioValidator.js'
import hostsService from '@/services/hostsService'
import configuracaoScoreService from '@/services/configuracaoScoreService'

export default {
  name: 'CronogramaConfig',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedHost: {
      type: Object,
      default: null
    },
    cronogramaData: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: 'Configurar Cronograma'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: false,
      form: {
        vcon: false,
        vpra: false,
        vsuc: false,
        vsup: false,
        vsyn: false,
        horarioVcon: '',
        horarioVpra: '',
        horarioVsuc: '',
        horarioVsup: '',
        horarioVsyn: '',
        logsVideo: false
      },
      horariosConflitantes: [],
      horarioMinimo: '',
      carregandoSugestao: false,
      erroHorarioMinimo: '',
      scoresSistemas: {},
      carregandoScores: false,
      scoresJaBuscados: false,
      configuracoesScore: {
        SCORE_LIMITE_ACEITO: 0,
        SCORE_LIMITE_BLOQUEIO: 0,
        DIAS_LIMITE_BLOQUEIO: 0
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    hostName() {
      return this.selectedHost ? this.selectedHost.name : ''
    },
    temConflitosHorario() {
      return this.horariosConflitantes.length > 0
    },
    temSistemasSelecionados() {
      return this.form.vcon || this.form.vpra || this.form.vsuc || this.form.vsup || this.form.vsyn
    },
    todosAtivados() {
      if (!this.selectedHost) return false
      
      // Verificar se todos os sistemas disponíveis estão ativados
      const sistemasDisponiveis = []
      if (this.selectedHost.hasVCON) sistemasDisponiveis.push('vcon')
      if (this.selectedHost.hasVPRA) sistemasDisponiveis.push('vpra')
      if (this.selectedHost.hasVSUC) sistemasDisponiveis.push('vsuc')
      if (this.selectedHost.hasVSUP) sistemasDisponiveis.push('vsup')
      if (this.selectedHost.hasVSYN) sistemasDisponiveis.push('vsyn')
      
      if (sistemasDisponiveis.length === 0) return false
      
      // Verificar se todos estão ativados
      return sistemasDisponiveis.every(sistema => {
        return this.form[sistema] === true
      })
    },
    dialogWidth() {
      if (!this.selectedHost) return '600px'
      
      // Contar quantos sistemas o host possui
      let sistemasCount = 0
      if (this.selectedHost.hasVCON) sistemasCount++
      if (this.selectedHost.hasVPRA) sistemasCount++
      if (this.selectedHost.hasVSUC) sistemasCount++
      if (this.selectedHost.hasVSUP) sistemasCount++
      if (this.selectedHost.hasVSYN) sistemasCount++
      
      // Largura base: 200px por sistema + 200px de padding
      const baseWidth = 200
      const padding = 200
      const calculatedWidth = (sistemasCount * baseWidth) + padding
      
      // Largura mínima de 400px e máxima de 1200px
      const minWidth = 400
      const maxWidth = 1200
      
      return `${Math.max(minWidth, Math.min(maxWidth, calculatedWidth))}px`
    }
  },
  watch: {
    'form.horarioVpra': {
      handler() {
        this.validarHorarios()
      }
    },
    'form.horarioVsuc': {
      handler() {
        this.validarHorarios()
      }
    },
    'form.horarioVsup': {
      handler() {
        this.validarHorarios()
      }
    },
    'form.horarioVcon': {
      handler() {
        this.validarHorarios()
      }
    },
    'form.horarioVsyn': {
      handler() {
        this.validarHorarios()
      }
    },
    'form.vcon': {
      handler() {
        this.validarHorarios()
      }
    },
    'form.vpra': {
      handler() {
        this.validarHorarios()
      }
    },
    'form.vsuc': {
      handler() {
        this.validarHorarios()
      }
    },
    'form.vsup': {
      handler() {
        this.validarHorarios()
      }
    },
    'form.vsyn': {
      handler() {
        this.validarHorarios()
      }
    },
    selectedHost: {
      handler(newHost) {
        if (newHost) {
          // Validar bloqueio de porta
          if (newHost.porta_bloqueio === true && newHost.porta_liberado !== true) {
            this.$emit('input', false)
            this.$emit('bloqueado', 'Este host possui bloqueio de porta, realize a liberação para poder configurar o cronograma.')
            return
          }
          
          this.resetForm()
          
          // Calcular e preencher horário mínimo baseado em horario_FimBackup
          if (newHost.horario_FimBackup) {
            const horarioMinimoCalculado = HorarioValidator.calcularHorarioMinimo(newHost.horario_FimBackup)
            if (horarioMinimoCalculado) {
              this.horarioMinimo = horarioMinimoCalculado
            }
          }

          // Resetar flag quando o host muda
          this.scoresJaBuscados = false
        }
      }
    },
    dialog: {
      handler(newValue) {
        if (newValue && this.selectedHost) {
          // Validar bloqueio de porta quando o diálogo é aberto
          if (this.selectedHost.porta_bloqueio === true && this.selectedHost.porta_liberado !== true) {
            this.$nextTick(() => {
              this.$emit('input', false)
              this.$emit('bloqueado', 'Este host possui bloqueio de porta, realize a liberação para poder configurar o cronograma.')
            })
            return
          }
          
          // Calcular e preencher horário mínimo quando o diálogo é aberto
          if (this.selectedHost.horario_FimBackup) {
            const horarioMinimoCalculado = HorarioValidator.calcularHorarioMinimo(this.selectedHost.horario_FimBackup)
            if (horarioMinimoCalculado) {
              this.horarioMinimo = horarioMinimoCalculado
            }
          }

          // Carregar configurações de score se ainda não foram carregadas
          if (!this.configuracoesScore.SCORE_LIMITE_ACEITO) {
            this.carregarConfiguracoesScore()
          }
          
          // Buscar scores de segurança quando o diálogo é aberto (apenas uma vez)
          if (!this.scoresJaBuscados) {
            this.buscarScoresSeguranca(this.selectedHost)
            this.scoresJaBuscados = true
          }
        } else if (!newValue) {
          // Resetar flag quando o diálogo é fechado
          this.scoresJaBuscados = false
        }
      }
    },
    cronogramaData: {
      handler(newData) {
        if (newData) {
          // Garantir que já tenhamos os dados completos antes de prosseguir
          setTimeout(() => {
            this.loadFormData(newData)
          }, 50)
        }
      },
      immediate: true
    }
  },
  mounted() {
    // Carregar configurações de score quando o componente é montado
    this.carregarConfiguracoesScore()
  },
  methods: {
    resetForm() {
      this.form = {
        vcon: false,
        vpra: false,
        vsuc: false,
        vsup: false,
        vsyn: false,
        horarioVcon: '',
        horarioVpra: '',
        horarioVsuc: '',
        horarioVsup: '',
        horarioVsyn: '',
        logsVideo: false
      }
      this.horariosConflitantes = []
      this.scoresSistemas = {}
      this.scoresJaBuscados = false
    },
    async buscarScoresSeguranca(host) {
      if (!host) return

      const sistemasParaCalcular = []
      
      if (host.hasVCON && host.vconVersion) {
        sistemasParaCalcular.push({ sistema: 'VCON', versao: host.vconVersion })
      }
      if (host.hasVPRA && host.vpraVersion) {
        sistemasParaCalcular.push({ sistema: 'VPRA', versao: host.vpraVersion })
      }
      if (host.hasVSUC && host.vsucVersion) {
        sistemasParaCalcular.push({ sistema: 'VSUC', versao: host.vsucVersion })
      }
      if (host.hasVSUP && host.vsupVersion) {
        sistemasParaCalcular.push({ sistema: 'VSUP', versao: host.vsupVersion })
      }
      if (host.hasVSYN && host.vsynVersion) {
        sistemasParaCalcular.push({ sistema: 'VSYN', versao: host.vsynVersion })
      }

      if (sistemasParaCalcular.length === 0) {
        this.scoresSistemas = {}
        return
      }

      this.carregandoScores = true
      try {
        const response = await hostsService.calcularScoreSeguranca(sistemasParaCalcular)
        
        if (response && response.success && response.scores) {
          // Mapear scores por sistema
          const scoresMap = {}
          response.scores.forEach(score => {
            scoresMap[score.sistema] = score
          })
          this.scoresSistemas = scoresMap
        } else {
          console.warn('Resposta de score inválida:', response)
          this.scoresSistemas = {}
        }
      } catch (error) {
        console.error('Erro ao buscar scores de segurança:', error)
        this.scoresSistemas = {}
      } finally {
        this.carregandoScores = false
      }
    },
    async carregarConfiguracoesScore() {
      try {
        const response = await configuracaoScoreService.buscarComoObjeto()
        // O interceptor do axios já retorna response.data, então response já é o objeto
        if (response && response.success) {
          // Converter todos os valores para number
          const loadedConfig = {}
          for (const key in response.configs) {
            loadedConfig[key] = parseFloat(response.configs[key])
          }
          this.configuracoesScore = { ...loadedConfig }
        } else {
          console.error('Erro ao carregar configurações de score:', response?.message)
        }
      } catch (error) {
        console.error('Erro ao carregar configurações de score:', error)
      }
    },
    getScoreColor(score) {
      if (!score) return 'grey'
      
      const limiteAceito = this.configuracoesScore.SCORE_LIMITE_ACEITO || 0
      
      if (score.bloqueado) {
        return 'error'
      } else if (score.peso_total >= limiteAceito) {
        return 'warning'
      } else {
        return 'success'
      }
    },
    getScoreTextColor(score) {
      if (!score) return 'white'
      
      // Sempre retorna branco, mas mantém a estrutura para consistência
      return 'white'
    },
    getScoreLabel(score) {
      if (!score) return ''
      
      const limiteAceito = this.configuracoesScore.SCORE_LIMITE_ACEITO || 0
      
      if (score.versao_nao_encontrada) {
        return 'Muito Antiga'
      } else if (score.bloqueado) {
        return 'Bloqueado'
      } else if (score.peso_total >= limiteAceito) {
        return `Score: ${score.peso_total.toFixed(1)}`
      } else {
        return `Score: ${score.peso_total.toFixed(1)}`
      }
    },
    getScoreNumber(score) {
      if (!score) return '0'
      
      if (score.versao_nao_encontrada) {
        return '999'
      }
      
      return Math.round(score.peso_total).toString()
    },
    deveMostrarIcone(score) {
      if (!score) return false
      
      // Mostrar ícone se score for 999 (versão não encontrada) ou 0 (atualizado)
      const scoreNumero = score.versao_nao_encontrada ? 999 : Math.round(score.peso_total)
      return scoreNumero === 999 || scoreNumero === 0
    },
    getScoreIcon(score) {
      if (!score) return ''
      
      if (score.versao_nao_encontrada || Math.round(score.peso_total) === 999) {
        return '⛔'
      }
      
      if (Math.round(score.peso_total) === 0) {
        return '✅'
      }
      
      return ''
    },
    getScoreCircleClass(score) {
      if (!score) return 'score-safe'
      
      const limiteAceito = this.configuracoesScore.SCORE_LIMITE_ACEITO || 0
      
      if (score.versao_nao_encontrada || score.bloqueado) {
        return 'score-danger'
      } else if (score.peso_total >= limiteAceito) {
        return 'score-warning'
      } else {
        return 'score-safe'
      }
    },
    getScoreDashArray(score) {
      // Circunferência do círculo: 2 * π * r = 2 * π * 45 ≈ 283
      const circumference = 2 * Math.PI * 45
      return `${circumference} ${circumference}`
    },
    getScoreDashOffset(score) {
      if (!score) return 0
      
      // Circunferência do círculo: 2 * π * r = 2 * π * 45 ≈ 283
      const circumference = 2 * Math.PI * 45
      
      // Calcular porcentagem baseada no score
      // Score máximo considerado: 30 (para visualização)
      // Se versão não encontrada, mostrar 100% (círculo completo)
      let percentage = 0
      
      if (score.versao_nao_encontrada) {
        percentage = 1.0 // 100%
      } else {
        // Normalizar o score para 0-1 (máximo 30)
        const maxScore = 30
        percentage = Math.min(score.peso_total / maxScore, 1.0)
      }
      
      // Calcular offset
      // Como o SVG já está rotacionado -90deg, o círculo começa do topo
      // O offset é calculado como: circumference * (1 - percentage)
      // Isso faz com que quanto maior o score, mais do círculo seja preenchido
      return circumference * (1 - percentage)
    },
    getScoreTooltip(score) {
      if (!score) return ''
      
      if (score.versao_nao_encontrada) {
        return `Versão ${score.versao_cliente} não encontrada no histórico\n` +
               `⚠️ Versão muito antiga - Atualização bloqueada\n` +
               `Recomenda-se atualização manual`
      }
      
      let tooltip = `Peso Total: ${score.peso_total.toFixed(1)}\n` +
                    `Dias Atrasado: ${score.diferenca_dias}\n` +
                    `Peso Dias: ${score.peso_dias.toFixed(1)}\n` +
                    `Versões Atrasadas: ${score.versoes_atrasadas}\n` +
                    `Peso Versões: ${score.peso_versoes}\n` +
                    `Versão no Cliente: ${score.versao_cliente}\n`
      
      // Adicionar versão mais atual se disponível
      if (score.versao_atual) {
        tooltip += `Versão mais Atual: ${score.versao_atual}\n`
      }
      
      // Adicionar versões mais recentes se disponível
      if (score.versoes_mais_recentes && score.versoes_mais_recentes.length > 0) {
        const versoes = score.versoes_mais_recentes.split(',')
        const versoesLimitadas = versoes.slice(0, 10) // Limitar a 10 versões
        
        tooltip += `\nPróximas Versões:\n`
        versoesLimitadas.forEach((versao, index) => {
          tooltip += `${index + 1}) ${versao.trim()}\n`
        })
        
        // Mostrar quantas versões faltam se houver mais de 10
        if (versoes.length > 10) {
          const versoesRestantes = versoes.length - 10
          tooltip += `[+${versoesRestantes}]\n`
        }
      }
      
      tooltip += `\n${score.bloqueado ? '⚠️ Atualização bloqueada por segurança' : '✓ Seguro para atualizar'}`
      
      return tooltip
    },
    isSistemaBloqueado(sistema) {
      const score = this.scoresSistemas[sistema]
      if (!score) return false
      return score.bloqueado === true
    },
    getMensagemBloqueio(sistema) {
      const score = this.scoresSistemas[sistema]
      if (!score) return ''
      
      if (score.versao_nao_encontrada) {
        return `Versão ${score.versao_cliente} muito antiga. Atualização bloqueada por segurança. Recomenda-se atualização manual.`
      }
      
      return `Sistema muito desatualizado (Score: ${score.peso_total.toFixed(1)}, ${score.diferenca_dias} dias atrasado). Atualização bloqueada por segurança. Recomenda-se atualização manual.`
    },
    loadFormData(cronogramaData) {
      if (cronogramaData) {
        // Para garantir que estamos acessando uma cópia limpa dos dados
        const dados = JSON.parse(JSON.stringify(cronogramaData));
        
        // Converter explicitamente para booleanos
        const vconValue = dados.vcon === true || dados.vcon === 'true' || false;
        const vpraValue = dados.vpra === true || dados.vpra === 'true' || false;
        const vsucValue = dados.vsuc === true || dados.vsuc === 'true' || false;
        const vsupValue = dados.vsup === true || dados.vsup === 'true' || false;
        const vsynValue = dados.vsyn === true || dados.vsyn === 'true' || false;
        const logsVideoValue = dados.logsVideo === true || dados.logsVideo === 'true' || false;
        
        this.form = {
          vcon: vconValue,
          vpra: vpraValue,
          vsuc: vsucValue,
          vsup: vsupValue,
          vsyn: vsynValue,
          horarioVcon: this.extractTime(dados.horarioVcon) || '00:00',
          horarioVpra: this.extractTime(dados.horarioVpra) || '00:00',
          horarioVsuc: this.extractTime(dados.horarioVsuc) || '00:00',
          horarioVsup: this.extractTime(dados.horarioVsup) || '00:00',
          horarioVsyn: this.extractTime(dados.horarioVsyn) || '00:00',
          logsVideo: logsVideoValue
        }
        
        // Forçar reatividade
        this.$forceUpdate()
      }
    },
    extractTime(timeString) {
      return HorarioValidator.extractTime(timeString)
    },
    validarHorarios() {
      const validacao = HorarioValidator.validarHorarios(this.form)
      this.horariosConflitantes = validacao.conflitos.map(conflito => conflito.mensagem)
      
      // Validar horários contra o mínimo permitido
      if (this.horarioMinimo && this.selectedHost && this.selectedHost.horario_FimBackup) {
        const horariosAbaixoDoMinimo = []
        
        if (this.form.vcon && this.form.horarioVcon && !HorarioValidator.validarHorarioMinimo(this.form.horarioVcon, this.horarioMinimo)) {
          horariosAbaixoDoMinimo.push(`VCON: ${this.form.horarioVcon} (mínimo: ${this.horarioMinimo})`)
        }
        if (this.form.vpra && this.form.horarioVpra && !HorarioValidator.validarHorarioMinimo(this.form.horarioVpra, this.horarioMinimo)) {
          horariosAbaixoDoMinimo.push(`VPRA: ${this.form.horarioVpra} (mínimo: ${this.horarioMinimo})`)
        }
        if (this.form.vsuc && this.form.horarioVsuc && !HorarioValidator.validarHorarioMinimo(this.form.horarioVsuc, this.horarioMinimo)) {
          horariosAbaixoDoMinimo.push(`VSUC: ${this.form.horarioVsuc} (mínimo: ${this.horarioMinimo})`)
        }
        if (this.form.vsup && this.form.horarioVsup && !HorarioValidator.validarHorarioMinimo(this.form.horarioVsup, this.horarioMinimo)) {
          horariosAbaixoDoMinimo.push(`VSUP: ${this.form.horarioVsup} (mínimo: ${this.horarioMinimo})`)
        }
        if (this.form.vsyn && this.form.horarioVsyn && !HorarioValidator.validarHorarioMinimo(this.form.horarioVsyn, this.horarioMinimo)) {
          horariosAbaixoDoMinimo.push(`VSYN: ${this.form.horarioVsyn} (mínimo: ${this.horarioMinimo})`)
        }
        
        if (horariosAbaixoDoMinimo.length > 0) {
          const mensagemMinimo = `Horários abaixo do mínimo permitido (${this.horarioMinimo}): ${horariosAbaixoDoMinimo.join(', ')}. O horário de fim de backup (${this.selectedHost.horario_FimBackup}) requer que os horários sejam no mínimo ${this.horarioMinimo}.`
          this.horariosConflitantes.push(mensagemMinimo)
        }
      }
    },
    toggleAtivarTudo() {
      if (!this.selectedHost) return
      
      // Determinar o estado desejado (inverter o estado atual)
      const novoEstado = !this.todosAtivados
      
      // Ativar/desativar apenas os sistemas disponíveis e não bloqueados para este host
      if (this.selectedHost.hasVCON && !this.isSistemaBloqueado('VCON')) {
        this.form.vcon = novoEstado
      }
      if (this.selectedHost.hasVPRA && !this.isSistemaBloqueado('VPRA')) {
        this.form.vpra = novoEstado
      }
      if (this.selectedHost.hasVSUC && !this.isSistemaBloqueado('VSUC')) {
        this.form.vsuc = novoEstado
      }
      if (this.selectedHost.hasVSUP && !this.isSistemaBloqueado('VSUP')) {
        this.form.vsup = novoEstado
      }
      if (this.selectedHost.hasVSYN && !this.isSistemaBloqueado('VSYN')) {
        this.form.vsyn = novoEstado
      }
      
      // Validar horários após a mudança
      this.$nextTick(() => {
        this.validarHorarios()
      })
    },
    cancel() {
      this.dialog = false
      this.$emit('cancel')
    },
    save() {
      this.$emit('save', this.form)
    },
    getIconeSistema(sistema) {
      const icones = {
        'VCON': '/ico_vcon.png',
        'VPRA': '/ico_vpra.png',
        'VSUC': '/ico_vsuc.png',
        'VSUP': '/ico_vsup.png',
        'VSYN': '/ico_vsyn.png'
      }
      return icones[sistema] || '/ico_default.png'
    },
    validarHorarioMinimo() {
      this.erroHorarioMinimo = ''
      
      if (!this.horarioMinimo) {
        return // Campo vazio é válido (opcional)
      }
      
      const [hora, minuto] = this.horarioMinimo.split(':').map(Number)
      
      // Validar que termina em 0
      if (minuto % 10 !== 0) {
        this.erroHorarioMinimo = 'O horário deve terminar em 0 (ex: 02:00, 03:10)'
        return
      }
      
      // Validar que está entre 01:30 e 07:00
      const minutosTotais = hora * 60 + minuto
      const minPermitido = 1 * 60 + 30 // 01:30
      const maxPermitido = 7 * 60 + 0 // 07:00
      
      if (minutosTotais < minPermitido || minutosTotais > maxPermitido) {
        this.erroHorarioMinimo = 'O horário deve estar entre 01:30 e 07:00'
        return
      }
    },
    async aplicarSugestaoHorarios() {
      if (!this.temSistemasSelecionados) {
        console.warn('Selecione pelo menos um sistema para aplicar a sugestão de horários')
        return
      }

      // Validar horário mínimo antes de prosseguir
      this.validarHorarioMinimo()
      if (this.erroHorarioMinimo) {
        return
      }

      this.carregandoSugestao = true
      try {
        // Identificar sistemas selecionados na ordem: VCON, VPRA, VSUC, VSUP, VSYN
        const sistemasSelecionados = []
        if (this.form.vcon) sistemasSelecionados.push('vcon')
        if (this.form.vpra) sistemasSelecionados.push('vpra')
        if (this.form.vsuc) sistemasSelecionados.push('vsuc')
        if (this.form.vsup) sistemasSelecionados.push('vsup')
        if (this.form.vsyn) sistemasSelecionados.push('vsyn')

        const quantidadeSistemas = sistemasSelecionados.length

        // Buscar sugestão de horários (backend já retorna com gap de 10 minutos)
        const response = await hostsService.getSugestaoHorarios(
          this.horarioMinimo || null,
          quantidadeSistemas
        )
        
        if (!response.success || !response.horarios || response.horarios.length === 0) {
          console.error('Não foi possível obter sugestões de horários')
          return
        }

        const horariosSugeridos = response.horarios

        // Mapear sistemas para seus campos de horário
        const sistemaParaCampo = {
          'vcon': 'horarioVcon',
          'vpra': 'horarioVpra',
          'vsuc': 'horarioVsuc',
          'vsup': 'horarioVsup',
          'vsyn': 'horarioVsyn'
        }

        // Aplicar horários retornados pelo backend (já com gap de 10 minutos)
        for (let i = 0; i < sistemasSelecionados.length && i < horariosSugeridos.length; i++) {
          const sistema = sistemasSelecionados[i]
          const campoHorario = sistemaParaCampo[sistema]
          const horario = horariosSugeridos[i]
          
          this.form[campoHorario] = horario
        }

        // Validar horários após aplicar sugestões
        this.$nextTick(() => {
          this.validarHorarios()
        })

        console.log('Horários sugeridos aplicados com sucesso!', horariosSugeridos)
      } catch (error) {
        console.error('Erro ao aplicar sugestão de horários:', error)
      } finally {
        this.carregandoSugestao = false
      }
    }
  }
}
</script>

<style scoped>
/* Diálogos modernos */
.modern-dialog .v-dialog__content {
  backdrop-filter: blur(5px);
}

.modern-dialog-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 100%);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25) !important;
}

.modern-dialog-card .v-card__title {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 24px !important;
}

/* Tema escuro para diálogos */
.theme-dark .modern-dialog-card {
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.95) 0%, rgba(45, 45, 45, 0.9) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.theme-dark .modern-dialog-card .v-card__title {
  background: linear-gradient(135deg, #2d2d2d 0%, #3d3d3d 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* Botões modernos */
.v-btn {
  border-radius: 8px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0.5px;
}

.v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.v-btn.v-btn--contained {
  background: linear-gradient(135deg, var(--v-primary-base) 0%, var(--v-primary-darken1) 100%);
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3);
}

.v-btn.v-btn--contained:hover {
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.4);
}

/* Campos de entrada modernos */
.v-text-field .v-input__control .v-input__slot {
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

.v-text-field .v-input__control .v-input__slot:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Container dos sistemas no cronograma */
.sistemas-container {
  gap: 16px;
  margin-bottom: 16px;
}

.system-cronograma-container {
  min-width: 180px;
  max-width: 200px;
  padding: 12px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.system-cronograma-container:hover {
  background: rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.theme-dark .system-cronograma-container {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.theme-dark .system-cronograma-container:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.15);
}

/* Container do botão Ativar Tudo */
.ativar-tudo-container {
  margin-top: 4px;
  margin-bottom: 12px;
  padding: 0;
}

/* Container de horário mínimo e sugestão */
.horario-sugestao-container {
  padding: 8px 0;
  margin-top: 4px;
  gap: 12px;
  align-items: flex-end;
}


/* Container do ícone grande */
.system-icon-container-large {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.system-icon-container-large.active {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
  border: 2px solid #4caf50;
}

.system-icon-container-large.inactive {
  background: linear-gradient(135deg, #e0e0e0 0%, #f5f5f5 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #e0e0e0;
}

.theme-dark .system-icon-container-large.active {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
  border: 2px solid #4caf50;
}

.theme-dark .system-icon-container-large.inactive {
  background: linear-gradient(135deg, #424242 0%, #616161 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  border: 2px solid #424242;
}

/* Ícone grande do sistema */
.sistema-icon-large {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.system-icon-container-large.active .sistema-icon-large {
  filter: brightness(1.1) contrast(1.1);
}

.system-icon-container-large.inactive .sistema-icon-large {
  filter: grayscale(0.3) brightness(0.8);
}

/* Ícones dos sistemas pequenos (mantido para compatibilidade) */
.system-icon-small {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.theme-dark .system-icon-small {
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Responsividade melhorada */
@media (max-width: 768px) {
  .modern-dialog-card .v-card__title {
    padding: 16px 20px !important;
  }
  
  .v-btn {
    font-size: 0.875rem !important;
  }
  
  .system-icon-small {
    width: 18px;
    height: 18px;
  }
  
  .system-cronograma-container {
    min-width: 150px;
    max-width: 160px;
    padding: 12px;
  }
  
  .system-icon-container-large {
    width: 80px;
    height: 80px;
  }
  
  .sistema-icon-large {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 600px) {
  .system-cronograma-container {
    min-width: 120px;
    max-width: 140px;
    padding: 8px;
  }
  
  .system-icon-container-large {
    width: 70px;
    height: 70px;
  }
  
  .sistema-icon-large {
    width: 50px;
    height: 50px;
  }
}
/* Classe para posicionar overlay corretamente */
.position-relative {
  position: relative;
  min-height: 300px;
}

/* Indicador circular de score no canto superior direito */
.score-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  width: 30px;
  height: 30px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.score-indicator:hover {
  transform: scale(1.1);
}

.score-circle {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg); /* Rotacionar para começar do topo */
}

.score-circle-bg {
  fill: none;
  stroke: #424242;
  stroke-width: 6;
}

.theme-dark .score-circle-bg {
  stroke: #616161;
}

.score-circle-progress {
  fill: none;
  stroke-width: 6;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.5s ease, stroke 0.3s ease;
}

.score-circle-progress.score-safe {
  stroke: #4caf50; /* Verde */
}

.score-circle-progress.score-warning {
  stroke: #ff9800; /* Laranja/Amarelo */
}

.score-circle-progress.score-danger {
  stroke: #f44336; /* Vermelho */
}

.score-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
}

.score-number {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  line-height: 1;
}

/* Indicador apenas com ícone (sem círculo) */
.score-icon-only {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.score-icon {
  font-size: 20px;
  line-height: 1;
  display: block;
}
</style>
